export function isUnreadRoom(room: any, currentUserId?: number | string) {
  const last = room?.last_message;
  if (!last || !currentUserId) return false;

  const lastUserId = last?.user?.id;

  return last.is_read === false && lastUserId !== currentUserId;
}
